

export function checkLength(name: string, length: number): string {
  return name.length <= length
    ? name
    : name.substring(0, length) + "...";
}
